import { DateInputLocalized } from '@components'

import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { EInvoiceStatus } from '@features/eInvoicing/constants/eInvoiceStatus'

import { useFormContext, useWatch } from '../../../../../../hooks/useForm'
import { useBillForm } from '../../contexts/billFormContext'
import { BillFormSchema } from '../../utils/formData'

export const BillBillDate = (): ReactElement => {
  const { t } = useTranslation()
  const { FormItem, control } = useFormContext<BillFormSchema>()
  const { eInvoiceStatus } = useBillForm()
  const isRefused = eInvoiceStatus === EInvoiceStatus.Refused
  const paymentDate = useWatch({ control, name: 'paymentDate' })

  return (
    <FormItem
      name="billDate"
      label={t('bill.edit.form.bill_date')}
      render={({ field }) => <DateInputLocalized maxDate={paymentDate} {...field} disabled={isRefused} />}
    />
  )
}
